import { DbConnection } from "./db";

export default class SharedDbConnection implements DbConnection {
  worker?: Worker;
  bc = new BroadcastChannel("db");
  bcActive = false;

  messages: Array<any> = [];
  cbs: Array<(ev: MessageEvent<any>) => void> = [];

  constructor() {
    this.bc.addEventListener("message", (ev) => {
      if (ev.data === "reset") {
        this.bcActive = false;
      } else if (ev.data === "pong") {
        this.bcActive = true;
        for (const msg of this.messages) {
          this.bc.postMessage(msg);
        }
        this.messages = [];
      }
      if (ev.data.type === "response") {
        for (const cb of this.cbs) {
          cb(ev);
        }
      }
    });

    navigator.locks.request("db", async () => {
      this.bc.postMessage("reset");
      this.bcActive = false;
      console.log("this tab has the lock");
      this.worker = new Worker(new URL("worker.js", import.meta.url), {
        type: "module",
      });
      this.worker.addEventListener("message", (ev) => {
        for (const cb of this.cbs) {
          cb(ev);
        }
      });
      for (const msg of this.messages) {
        this.worker.postMessage(msg);
      }
      this.messages = [];

      // we never ever give the lock back.
      await new Promise(() => {});
    });
    this.bc.postMessage("ping");
  }

  postMessage(msg: any) {
    if (this.worker) {
      this.worker.postMessage(msg);
    } else if (this.bcActive) {
      this.bc.postMessage(msg);
    } else {
      this.messages.push(msg);
    }
  }

  addEventListener(_type: "message", cb: (ev: MessageEvent<any>) => void) {
    this.cbs.push(cb);
  }
}
